"use client";
import React from "react";
import GameTimestamp from "../timestamp";
import TeamLogo from "@/components/team/logo";
import PickChip from "./pick-chip";
import Link from "next/link";
import { createTeamSlug } from "@/utils/url";
import GameDetailScore from "./score";
import { useGame } from "@/utils/providers/game";
export default function GameDetailHeader() {
  const ctx = useGame();

  if (ctx.game) {
    console.log(ctx.game);
    let negativeBottom: string = "";

    if (ctx.game.series) {
      if (ctx.game.league === "mlb" && ctx.game.status === "InProgress") {
        negativeBottom = "-bottom-10";
      } else {
        negativeBottom = "-bottom-12";
      }
    } else {
      if (ctx.game.league === "mlb" && ctx.game.status === "InProgress") {
        negativeBottom = "-bottom-10";
      } else {
        negativeBottom = "-bottom-12 sm:-bottom-10";
      }
    }
    return (
      <>
        {/* OUTER HEADER CONTAINER */}
        <div
          className={`bg-secondary-300  h-[344px] desktop-grid:h-[369px] relative overflow-hidden`}
        >
          {ctx.game.series && (
            <div
              className="relative flex h-[26px] justify-center items-center z-[3]"
              style={{
                backgroundImage: `linear-gradient(to right, #${ctx.game.awayTeam.primaryColor} 41.63%, #${ctx.game.homeTeam.primaryColor} 57.87%)`,
              }}
            >
              <div className="text-body-sm-medium uppercase text-white">
                {ctx.game.series}
              </div>
            </div>
          )}
          {/* PARTICLES */}
          <div className="block desktop-grid:hidden">
            <img
              src={`/images/ui/game-detail-header-mobile-left.png`}
              alt=""
              className="h-[120%] z-[1] absolute left-[-240px] min-[430px]:left-[-260px] top-[-25px] opacity-40"
              style={{
                backgroundImage: `linear-gradient(to right, #${ctx.game.awayTeam.primaryColor} 240px, rgba(255, 255, 255, 0) 100%)`,
              }}
            />
          </div>
          <div className="hidden desktop-grid:block">
            <img
              src={`/images/ui/game-detail-header-right.png`}
              alt=""
              className="w-full h-[115%] z-[1] absolute desktop-grid:left-0 top-0 desktop-grid:max-w-[30%] max-w-[300px] -left-[15%] -scale-x-100 opacity-50"
              style={{
                backgroundImage: `linear-gradient(to left, #${ctx.game.awayTeam.primaryColor} 0%, rgba(255, 255, 255, 0) 70%)`,
              }}
            />
          </div>
          <div className="block desktop-grid:hidden">
            <img
              src={`/images/ui/game-detail-header-mobile-right.png`}
              alt=""
              className="h-[115%] z-[1] absolute right-[-240px] min-[430px]:right-[-260px] top-0 opacity-40"
              style={{
                backgroundImage: `linear-gradient(to left, #${ctx.game.homeTeam.primaryColor} 240px, rgba(255, 255, 255, 0) 100%)`,
              }}
            />
          </div>
          <div className="hidden desktop-grid:block">
            <img
              src={`/images/ui/game-detail-header-right.png`}
              alt=""
              className="w-full h-[115%] z-[1] absolute desktop-grid:right-0 top-0 desktop-grid:max-w-[30%] max-w-[300px] -right-[15%] opacity-50"
              style={{
                backgroundImage: `linear-gradient(to left, #${ctx.game.homeTeam.primaryColor} 0%, rgba(255, 255, 255, 0) 70%)`,
              }}
            />
          </div>
          <div
            className={`container h-full relative flex justify-start pt-0 items-center flex-col`}
          >
            {/* META */}
            <div
              className={`hidden desktop-grid:block absolute w-full top-[28px]`}
            >
              <div className="flex flex-row absolute left-0 px-6 w-full z-[1]">
                <PickChip
                  showAvatars
                  totalPicks={ctx.game.totalPicks}
                  avatars={ctx.game.avatars || []}
                  totalBettors={ctx.game.totalBettors || 0}
                  totalPicksForSale={ctx.game.totalPicksForSale}
                  totalComments={ctx.game.discussion.total_comments || 0}
                  side="right"
                  dark
                />
              </div>
              {/* <div className="flex flex-row absolute px-6 w-full justify-between items-start gap-4 z-[1]">
                <Badge
                  color="white"
                  value={data.totalPicks}
                  showZero={true}
                  icon={
                    data.totalPicks && data.totalPicks > 0
                      ? { idKey: -1, name: "flame", gradient: "flame" }
                      : undefined
                  }
                  label={`Pick${data.totalPicks != 1 ? "s" : ""}`}
                />
                <PickGroup
                  avatars={data.avatars || []}
                  totalBettors={data.totalBettors || 0}
                  totalPicksForSale={data.totalPicksForSale}
                  side="right"
                  dark
                ></PickGroup>
              </div> */}
              {/* <div className="flex flex-row absolute h-[15.875rem] right-6 items-start">
              <div className="flex items-center gap-4">
                <span className="text-title-bold text-white">Share</span>
                <Button variant="circle" color="light">
                  <Icon name="share" size="sm"></Icon>
                </Button>
              </div>
            </div> */}
            </div>
            {/* LOGO SPLASH */}
            <div className="flex pointer-events-none z-[0] absolute w-[50%] h-full desktop-grid:w-[30rem] desktop-grid:h-[30rem] desktop-grid:-top-1/4 -left-5 opacity-20 desktop-grid:flex justify-center items-center top-0">
              <div
                className="w-full h-full absolute"
                style={{
                  background: `linear-gradient(270deg, rgba(35, 37, 40, 0) 30%, rgba(35, 37, 40, 1) 100%)`,
                }}
              ></div>
              <img
                src={ctx.game.awayTeam.logoUrl}
                className="w-full object-contain"
              />
            </div>
            <div className="flex pointer-events-none z-[0] absolute w-[50%] h-full desktop-grid:w-[30rem] desktop-grid:h-[30rem] desktop-grid:-top-1/4 -right-5 opacity-20 desktop-grid:flex justify-center items-center top-0">
              <div
                className="w-full h-full absolute"
                style={{
                  background: `linear-gradient(90deg, rgba(35, 37, 40, 0) 30%, rgba(35, 37, 40, 1) 100%)`,
                }}
              ></div>
              <img
                src={ctx.game.homeTeam.logoUrl}
                className="w-full object-contain"
              />
            </div>
            {/* INNER CONTAINER */}
            <div className="flex flex-col relative w-full max-w-[462px] mx-auto z-[1]">
              {/* HEADER */}
              <div className="flex flex-col gap-1 relative">
                {/* HEADLINE */}
                <div className="flex flex-row justify-center text-center items-center gap-2 text-headline-lg text-white mt-7 uppercase">
                  <span className="block xs:hidden">
                    {ctx.game.awayTeam.abbreviation}
                  </span>
                  <span className="hidden xs:block">
                    {ctx.game.awayTeam.name}
                  </span>
                  <span className="text-title-lg-medium">@</span>
                  <span className="block xs:hidden">
                    {ctx.game.homeTeam.abbreviation}
                  </span>
                  <span className="hidden xs:block">
                    {ctx.game.homeTeam.name}
                  </span>
                </div>
                {/* PLACEHOLDER GAP */}
                <div className="h-[14px] w-full"></div>
                {/* ANCHORED TO HEADLINE */}
                <div className="absolute top-14 left-0 right-0 w-full flex justify-center">
                  <GameTimestamp
                    type="full"
                    dateTime={ctx.game.dateTime}
                    platform={ctx.game.platform}
                    className="text-title-sm-bold"
                    ctx={ctx}
                    dark
                  />
                </div>
                {/* 3 COLUMN LAYOUT - LOGOS WITH INNER CONTENT */}
                <div
                  className={`grid grid-cols-[minmax(48px,100px)_minmax(166px,277px)_minmax(48px,100px)] justify-center relative gap-0 text-white -mt-6`}
                >
                  <div className="flex justify-start flex-col items-center">
                    {/* AWAY TEAM */}
                    <Link
                      href={createTeamSlug(ctx.game.league, ctx.game.awayTeam)}
                      className="flex flex-col items-center"
                    >
                      <TeamLogo
                        team={ctx.game.awayTeam}
                        sport={ctx.game.league}
                        size="lg"
                      />
                      <div className="text-title-sm-medium text-white whitespace-nowrap flex flex-row gap-0.5">
                        <span>{ctx.game.awayTeam.abbreviation}</span>
                        <span className="hidden sm:block">
                          {ctx.game.awayTeam.name}
                        </span>
                      </div>
                      <div className="text-body-sm text-secondary-700 mt-1">
                        {ctx.game.league === "nhl" ? (
                          <>
                            {ctx.game.awayRecord.wins}-
                            {ctx.game.awayRecord.losses}-
                            {ctx.game.awayRecord.overtimeLosses}
                          </>
                        ) : (
                          <>
                            {ctx.game.awayRecord.wins}-
                            {ctx.game.awayRecord.losses}
                          </>
                        )}
                      </div>
                      <span className="text-label-lg-medium text-secondary-700 uppercase mt-1">
                        away team
                      </span>
                    </Link>
                  </div>
                  <GameDetailScore dark size="lg" />
                  <div className="flex justify-start flex-col items-center">
                    {/* HOME TEAM */}
                    <Link
                      href={createTeamSlug(ctx.game.league, ctx.game.homeTeam)}
                      className="flex flex-col items-center"
                    >
                      <TeamLogo
                        team={ctx.game.homeTeam}
                        sport={ctx.game.league}
                        size="lg"
                      />
                      <div className="text-title-sm-medium text-white whitespace-nowrap flex flex-row gap-0.5">
                        <span>{ctx.game.homeTeam.abbreviation}</span>
                        <span className="hidden sm:block">
                          {ctx.game.homeTeam.name}
                        </span>
                      </div>
                      <div className="text-body-sm text-secondary-700 mt-1">
                        {ctx.game.league === "nhl" ? (
                          <>
                            {ctx.game.homeRecord.wins}-
                            {ctx.game.homeRecord.losses}-
                            {ctx.game.homeRecord.overtimeLosses}
                          </>
                        ) : (
                          <>
                            {ctx.game.homeRecord.wins}-
                            {ctx.game.homeRecord.losses}
                          </>
                        )}
                      </div>
                      <span className="text-label-lg-medium text-secondary-700 uppercase mt-1">
                        home team
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
              {/* LIVE MLB INNING STATUS */}
              {ctx.isLive && ctx.game.league === "mlb" && (
                <div className="-mt-10 flex w-full h-[82px] items-center justify-center gap-6 scale-75 desktop-grid:scale-100">
                  <div className="relative w-[33px]">
                    <div className="inline-flex gap-[5px] flex-row flex-wrap w-[33px] rotate-45">
                      <div
                        className={`w-[14px] h-[14px] border-[2px] ${
                          ctx.currentPeriod?.onSecond
                            ? "bg-primary-500 border-primary-500"
                            : "bg-transparent border-secondary-700"
                        }`}
                      ></div>
                      <div
                        className={`w-[14px] h-[14px] border-[2px] ${
                          ctx.currentPeriod?.onFirst
                            ? "bg-primary-500 border-primary-500"
                            : "bg-transparent border-secondary-700"
                        }`}
                      ></div>
                      <div
                        className={`w-[14px] h-[14px] border-[2px] ${
                          ctx.currentPeriod?.onThird
                            ? "bg-primary-500 border-primary-500"
                            : "bg-transparent border-secondary-700"
                        }`}
                      ></div>
                    </div>
                  </div>
                  <div className="flex flex-col gap-2">
                    <div className="flex flex-row items-center text-title-sm-bold text-secondary-600 gap-2">
                      <span>B:</span>
                      <div className="flex flex-row gap-1 items-center">
                        <div
                          className={`w-[10px] h-[10px] rounded-full border-[2px] ${
                            ctx.currentPeriod?.balls !== undefined &&
                            ctx.currentPeriod?.balls >= 1
                              ? "bg-primary-500 border-primary-500"
                              : "bg-transparent border-secondary-600"
                          }`}
                        ></div>
                        <div
                          className={`w-[10px] h-[10px] rounded-full border-[2px] ${
                            ctx.currentPeriod?.balls !== undefined &&
                            ctx.currentPeriod?.balls >= 2
                              ? "bg-primary-500 border-primary-500"
                              : "bg-transparent border-secondary-600"
                          }`}
                        ></div>
                        <div
                          className={`w-[10px] h-[10px] rounded-full border-[2px] ${
                            ctx.currentPeriod?.balls !== undefined &&
                            ctx.currentPeriod?.balls >= 3
                              ? "bg-primary-500 border-primary-500"
                              : "bg-transparent border-secondary-600"
                          }`}
                        ></div>
                        <div
                          className={`w-[10px] h-[10px] rounded-full border-[2px] ${
                            ctx.currentPeriod?.balls !== undefined &&
                            ctx.currentPeriod?.balls >= 4
                              ? "bg-primary-500 border-primary-500"
                              : "bg-transparent border-secondary-600"
                          }`}
                        ></div>
                      </div>
                    </div>
                    <div className="flex flex-row items-center text-title-sm-bold text-secondary-600 gap-2">
                      <span>S:</span>
                      <div className="flex flex-row gap-1 items-center">
                        <div
                          className={`w-[10px] h-[10px] rounded-full border-[2px] ${
                            ctx.currentPeriod?.strikes !== undefined &&
                            ctx.currentPeriod?.strikes >= 1
                              ? "bg-primary-500 border-primary-500"
                              : "bg-transparent border-secondary-600"
                          }`}
                        ></div>
                        <div
                          className={`w-[10px] h-[10px] rounded-full border-[2px] ${
                            ctx.currentPeriod?.strikes !== undefined &&
                            ctx.currentPeriod?.strikes >= 2
                              ? "bg-primary-500 border-primary-500"
                              : "bg-transparent border-secondary-600"
                          }`}
                        ></div>
                        <div
                          className={`w-[10px] h-[10px] rounded-full border-[2px] ${
                            ctx.currentPeriod?.strikes !== undefined &&
                            ctx.currentPeriod?.strikes >= 3
                              ? "bg-primary-500 border-primary-500"
                              : "bg-transparent border-secondary-600"
                          }`}
                        ></div>
                      </div>
                    </div>
                    <div className="flex flex-row items-center text-title-sm-bold text-secondary-600 gap-2">
                      <span>O:</span>
                      <div className="flex flex-row gap-1 items-center">
                        <div
                          className={`w-[10px] h-[10px] rounded-full border-[2px] ${
                            ctx.currentPeriod?.outs !== undefined &&
                            ctx.currentPeriod?.outs >= 1
                              ? "bg-primary-500 border-primary-500"
                              : "bg-transparent border-secondary-600"
                          }`}
                        ></div>
                        <div
                          className={`w-[10px] h-[10px] rounded-full border-[2px] ${
                            ctx.currentPeriod?.outs !== undefined &&
                            ctx.currentPeriod?.outs >= 2
                              ? "bg-primary-500 border-primary-500"
                              : "bg-transparent border-secondary-600"
                          }`}
                        ></div>
                        <div
                          className={`w-[10px] h-[10px] rounded-full border-[2px] ${
                            ctx.currentPeriod?.outs !== undefined &&
                            ctx.currentPeriod?.outs >= 3
                              ? "bg-primary-500 border-primary-500"
                              : "bg-transparent border-secondary-600"
                          }`}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div
                className={`mt-4 hidden desktop-grid:flex justify-center text-label-lg-medium text-white`}
              >
                {ctx.game.temperature && <span>{ctx.game.temperature}°</span>}{" "}
                {ctx.game.stadium?.name}
              </div>
            </div>
            {/* META */}
            <div className="flex desktop-grid:hidden justify-between items-center w-full gap-4 relative mb-4 z-[2]">
              <div
                className={`absolute ${negativeBottom} inset-0 flex justify-center items-center`}
              >
                {/* <PickChip
                showAvatars
                  idKey={-2}
                  totalPicks={data.totalPicks}
                  avatars={data.avatars || []}
                  totalBettors={data.totalBettors || 0}
                  totalPicksForSale={data.totalPicksForSale}
                  side="right"
                  dark
                /> */}
              </div>
              {/* <Badge
                color="white"
                value={data.totalPicks}
                showZero={true}
                icon={
                  data.totalPicks && data.totalPicks > 0
                    ? { idKey: -2, name: "flame", gradient: "flame" }
                    : undefined
                }
                label={`Pick${data.totalPicks != 1 ? "s" : ""}`}
              /> */}
              {/* Footer */}

              {/* <PickGroup
                avatars={data.avatars || []}
                totalBettors={data.totalBettors || 0}
                totalPicksForSale={data.totalPicksForSale}
                side="right"
                dark
              ></PickGroup> */}
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return <div>Loading...</div>;
  }
}
